<template>
    <div class="pb-12">
        <h1 class="page-title">
            Obsah knihy {{ book?.title?.split("|")[0]?.trim() }}
        </h1>
        <div
            v-if="kapitoly"
            class="grid grid-cols-2 gap-10 md:grid-cols-4"
        >
            <TextyKapitola
                v-for="kapitola in kapitoly"
                :key="kapitola.kod"
                :item="kapitola"
                :children="getChildren(kapitola.kod)"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
const localePath = useLocalePath()
const { locale } = useI18n()
const booksStore = useBooksStore()

const { book } = defineProps<{ book: BookItem }>()

const kapitoly = computed(() => {
    return booksStore.bookTrees[locale.value as LanguageCode][book.kod]?.filter(
        item => item.style === "uap02"
    )
})

/* watch(locale, () => {
    setTimeout(async () => {
        await navigateTo(localePath(`/texty`))
    }, 300)
}) */
watch(locale, async () => {
    await navigateTo(localePath(`/texty`))
})

function getChildren(kapitolaKod: string) {
    // vyber všetky podkapitoly (uap03 a uap04 s jednou tečkou v kóde)
    /* const children = booksStore.bookTrees[locale.value as LanguageCode][
        book.kod
    ]?.filter(
        item =>
            item.kod.split(".").length === 3 &&
            item.kod.split(".")[0] === kapitolaKod
    ) */
    const children = booksStore.bookTrees[locale.value as LanguageCode][
        book.kod
    ]?.filter(
        item =>
            (item.style === "uap03" ||
                ((kapitolaKod === "1" || item.kniha === "500") &&
                    item.style === "uap04")) &&
            item.kod.split(".")[0] === kapitolaKod
    )
    return children
}
</script>

<style scoped></style>
